import { useCallback, useState } from 'react';
import { emptyItem, IBatchItem } from '../claimsBatchEdit.type';

export const useBatchEditFields = () => {
  const [items, setItems] = useState<IBatchItem[]>([emptyItem()]);

  const add = useCallback(() => {
    setItems((r) => [...r, emptyItem()]);
  }, []);

  const change = useCallback(
    (item: IBatchItem) => {
      const newValues = items.map((r) => (r.id === item.id ? item : r));
      setItems(newValues);
    },
    [items],
  );

  const remove = useCallback(
    (item: IBatchItem) =>
      setItems((oldItems) => {
        const result = oldItems.filter((r) => r.id !== item.id);
        return result.length > 0 ? result : [emptyItem()];
      }),
    [],
  );

  const clearAll = useCallback(() => {
    setItems([emptyItem()]);
  }, []);

  return { items, add, change, remove, clearAll };
};
